<div>
    <div class="page-title">
        <h1>Rates Setup
            <button class="btn btn-primary" (click)="openModal()">Create New</button>
        </h1>
    </div>
    
  <div class="page-body">
    <!-- <div class="row">
      <div class="col-md-3">
        <div class="form-group">
            <label for="">Search</label>
            <input type="text" class="form-control" [(ngModel)]="tableModel.search">
        </div>
      </div>
      <div class="col-md-3" style="align-content: center;">
        <button class="btn btn-primary mr-3" (click)="getList()">Search</button>
        <button class="btn btn-primary" (click)="reset()">Reset</button>
      </div>
    </div> -->
    <div class="card mt-3">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="dataSource.data.length>0">

        <!--- Note that these columns can be defined in any order.
                      The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="serialId">
          <th mat-header-cell *matHeaderCellDef> Serial ID </th>
          <td mat-cell *matCellDef="let element"> {{element.serialId}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="rateType">
          <th mat-header-cell *matHeaderCellDef> Rate Type </th>
          <td mat-cell *matCellDef="let element"> {{element.rateType==0?'Percentage':'Value'}} </td>
        </ng-container>

        <!-- Weight Column -->
        <!-- <ng-container matColumnDef="parcelType">
          <th mat-header-cell *matHeaderCellDef> Parcel Type </th>
          <td mat-cell *matCellDef="let element"> {{element.parcelType}} </td>
        </ng-container> -->

        <!-- Symbol Column -->
        <ng-container matColumnDef="ratePercentage">
          <th mat-header-cell *matHeaderCellDef> Rate Percentage </th>
          <td mat-cell *matCellDef="let element"> {{element.ratePercentage}} </td>
        </ng-container>

        <ng-container matColumnDef="rateValue">
          <th mat-header-cell *matHeaderCellDef> Rate Value </th>
          <td mat-cell *matCellDef="let element"> {{element.rateValue}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Rate Value </th>
          <td mat-cell *matCellDef="let element"> 
            <p><mat-slide-toggle [(ngModel)]="element.status" (change)="onToggle($event,element.serialId)"></mat-slide-toggle></p> </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <i class="icon-pencil icon-btn" (click)="openModal(element.serialId)"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <h4 class="text-center" *ngIf="!(dataSource.data.length>0)">No Records Found</h4>
      <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons (page)="onPaginate($event)"
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div>
</div>